import type { SVGProps } from "react";

export function CloseSquareDuotoneLine(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1.5em"
      height="1.5em"
      {...props}
    >
      <defs>
        <mask id="letsIconsCloseSquareDuotoneLine0">
          <g fill="none" strokeWidth="1.2">
            <circle
              cx="12"
              cy="12"
              r="8.4"
              stroke="silver"
              strokeOpacity=".25"
            ></circle>
            <path
              stroke="#fff"
              strokeLinecap="square"
              strokeLinejoin="round"
              d="m16 8l-8 8m0-8l8 8"
            ></path>
          </g>
        </mask>
      </defs>
      <path
        fill="currentColor"
        d="M0 0h24v24H0z"
        mask="url(#letsIconsCloseSquareDuotoneLine0)"
      ></path>
    </svg>
  );
}
